// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-InternalHeader-styles--root--hTvhW {
  color: #262626;
  color: var(--mainForeground);
}

.src-components-InternalHeader-styles--root--hTvhW > h2,
.src-components-InternalHeader-styles--root--hTvhW > p {
  margin: 0;
  margin: initial;
  padding: 0;
  padding: initial;
}

.src-components-InternalHeader-styles--root--hTvhW > h2 {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.25;
}

@media screen and (min-width: 768px) {

.src-components-InternalHeader-styles--root--hTvhW > h2 {
    font-size: 22px;
    line-height: 1.14;
}
  }

.src-components-InternalHeader-styles--root--hTvhW > p {
  display: none;
}

@media screen and (min-width: 768px) {

.src-components-InternalHeader-styles--root--hTvhW > p {
    display: block;
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.58;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/InternalHeader/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,cAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;;EAEE,SAAe;EAAf,eAAe;EACf,UAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AAMnB;;AAJE;;AALF;IAMI,eAAe;IACf,iBAAiB;AAErB;EADE;;AAGF;EACE,aAAa;AAQf;;AANE;;AAHF;IAII,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AAErB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  color: var(--mainForeground);\n}\n\n.root > h2,\n.root > p {\n  margin: initial;\n  padding: initial;\n}\n\n.root > h2 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.25;\n\n  @media (--desktop) {\n    font-size: 22px;\n    line-height: 1.14;\n  }\n}\n\n.root > p {\n  display: none;\n\n  @media (--desktop) {\n    display: block;\n    margin-top: 10px;\n    font-size: 14px;\n    line-height: 1.58;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-InternalHeader-styles--root--hTvhW`
};
module.exports = ___CSS_LOADER_EXPORT___;
